import React from "react";

function TopBarBeforeUpload({ openFileDialog }) {
  return (
    <header className="top-bar">
      {/* Left Back Button */}
      <i
        className="fa-solid fa-arrow-left back-button"
        style={{ color: "white", cursor: "pointer" }}
        onClick={() => {window.location.href = "https://photoprints.opticonframing.com.au/";}}
      ></i>


      {/* Divider between left button & Add Photos */}
      <div className="divider"></div>

      {/* Add Photos Button */}
      <button onClick={openFileDialog} className="add-button">
        <span className="icon-box">
          <i className="fa-solid fa-camera-retro" style={{ marginRight: "8px" }}></i>
        </span>
        <span className="btn-text">Add Photos</span>
      </button>
    </header>
  );
}

export default TopBarBeforeUpload;
